export default __webpack_public_path__ + "static/media/robotBgDec1.bf96b5b0.png";